export class InsuredTripPartner {
  firstName: string;
  surname: string;
  dateOfBirth: string;
}
